/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, cx, jsx } from '@atlaskit/css';
import SmartLinkListIcon from '@atlaskit/icon/core/smart-link-list';
import { Anchor, Box, Inline, Pressable, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { SearchIcon } from './search-icon';

const styles = cssMap({
	root: {
		paddingTop: token('space.050'),
		paddingRight: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.050'),
		backgroundColor: token('color.background.input'),
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
	},
	tabOptionStyles: {
		backgroundColor: token('color.background.input'),
		paddingLeft: token('space.075'),
		paddingRight: token('space.100'),
		borderRadius: token('radius.small'),
		height: '22px',
	},
	tabOptionLinkStyles: {
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'none',
		},
	},
	tabOptionSelectedStyles: {
		backgroundColor: token('color.background.selected'),
	},
	searchIconWrapperStyles: {
		width: '16px',
		height: '16px',
	},
});

type AIModeTabsProps = {
	query: string;
	tenantDomain?: string;
};

export const AIModeTabs: ({ query, tenantDomain }: AIModeTabsProps) => JSX.Element = ({
	query,
	tenantDomain,
}: AIModeTabsProps) => {
	return (
		<Box xcss={styles.root}>
			<Inline space="space.0">
				<Pressable xcss={cx(styles.tabOptionStyles, styles.tabOptionSelectedStyles)}>
					<Inline space="space.050" alignBlock="center">
						<SmartLinkListIcon color={token('color.icon.selected')} label="" />
						{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
						<Text color="color.text.selected" weight="medium">
							Results
						</Text>
					</Inline>
				</Pressable>
				<Anchor
					xcss={cx(styles.tabOptionStyles, styles.tabOptionLinkStyles)}
					href={`${tenantDomain}/wiki/ai-search/?aiSearchQuery=${query}`}
				>
					<Inline space="space.050" alignBlock="center">
						<Box xcss={styles.searchIconWrapperStyles}>
							<SearchIcon />
						</Box>
						{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
						<Text color="color.text.subtle" weight="medium">
							AI Mode
						</Text>
					</Inline>
				</Anchor>
			</Inline>
		</Box>
	);
};
